<template lang="pug">
li
  span.sentencia-actual(v-if="isCurrentId")
    | {{ title }}
  span(v-else-if="!is_allowed")
    | {{ title }}
  a(:href="url_for_rails_documento_show(id)" v-else)
    | {{ title }}
  ul(v-if="hasRecurridas")
    documents-iter-procesal-detail-vue(
      v-for="iter in recurridas"
      :key=`documents-iter-procesal-detail-vue-${id}`
      :current-id="currentId"
      v-bind="recurridas"
    )
</template>

<script>
import mixins from 'common/mixins'

export default {
  name: 'documents-iter-procesal-detail-vue',
  props: {
    currentId: { type: Number, default: 0 },
    id: { type: Number, default: 0 },
    origen: { type: String, default: '' },
    sala: { type: String, default: '' },
    fecha: { type: String, default: '' },
    recurridas: { type: Array, default: () => [] },
    is_allowed: { type: Boolean, default: false }
  },
  mixins: [mixins.translate, mixins.requests],
  computed: {
    isCurrentId() {
      return this.currentId == this.id
    },
    title() {
      return `${this.origen} ${this.sala} ${this.fecha}`
    },
    hasRecurridas() {
      return this.recurridas.length > 0
    },
  }
}
</script>
